module.exports = __webpack_public_path__ + "img/share.3e9f852c.svg";